<template>
  <OrbitStrategyCreateModal
    v-if="action === 'modify'"
    :visible="visible"
    mode="modify"
    :robot="robot"
    exchange="OKX"
    :submitting="submitting"
    @update:visible="$emit('update:visible', $event)"
    @submit="submitModify"
  />
  <transition v-else name="orbit-action" appear>
    <div v-if="visible" class="orbit-action" @click.self="close">
      <section class="orbit-action__panel" role="dialog" aria-modal="true" :aria-label="title">
        <header>
          <h2>{{ title }}</h2>
          <button type="button" :disabled="submitting" :aria-label="$t('关闭')" @click="close"><i class="el-icon-close" /></button>
        </header>
        <div class="orbit-action__summary"><strong>UPlus-Orbit AI</strong><span>OKX</span></div>
        <p :class="{ 'is-danger': action === 'delete' }">{{ message }}</p>
        <footer>
          <button type="button" :disabled="submitting" @click="close">{{ $t('取消') }}</button>
          <button type="button" :class="{ 'is-danger': action === 'delete' }" :disabled="submitting" @click="submit">
            {{ submitting ? $t('处理中…') : $t('确认') }}
          </button>
        </footer>
      </section>
    </div>
  </transition>
</template>

<script>
import OrbitStrategyCreateModal from './OrbitStrategyCreateModal.vue'

export default {
  name: 'OrbitStrategyActionModal',
  components: { OrbitStrategyCreateModal },
  props: {
    visible: Boolean,
    submitting: Boolean,
    action: { type: String, default: 'modify' },
    robot: { type: Object, default: () => ({ raw: {} }) }
  },
  computed: {
    title() {
      return this.$t({ pause: '暂停机器人策略', resume: '恢复机器人策略', delete: '删除机器人策略' }[this.action] || '修改机器人策略')
    },
    message() {
      if (this.action === 'delete') return this.$tk('robot.del_term_tip')
      if (this.action === 'pause') return this.$tk('robot.current_strategys')
      return this.$t('确认恢复当前策略？')
    }
  },
  methods: {
    close() {
      if (!this.submitting) this.$emit('update:visible', false)
    },
    submitModify(payload) {
      if (!this.submitting) this.$emit('submit', { action: 'modify', robot: this.robot, form: { amount: payload.amount } })
    },
    submit() {
      if (!this.submitting) this.$emit('submit', { action: this.action, robot: this.robot })
    }
  }
}
</script>

<style scoped>
.orbit-action { position: fixed; inset: 0; z-index: 13250; display: flex; align-items: center; justify-content: center; padding: 24px; background: rgba(20, 17, 38, .46); }
.orbit-action__panel { box-sizing: border-box; width: 520px; max-width: 100%; padding: 26px; border-radius: 16px; background: #fff; color: #1b2232; }
.orbit-action header { display: flex; justify-content: space-between; align-items: center; gap: 16px; }
.orbit-action h2 { margin: 0; font-size: 18px; font-weight: 700; }
.orbit-action header button { border: 0; background: none; color: #929bb0; font-size: 18px; cursor: pointer; }
.orbit-action__summary { display: flex; justify-content: space-between; gap: 12px; margin: 20px 0; padding: 16px; border: 1px solid #eef0f5; border-radius: 10px; background: #f7f9fc; font-size: 14px; }
.orbit-action__summary span { color: #79808f; }
.orbit-action p { margin: 0; padding: 16px; border: 1px solid #dfe8fd; border-radius: 10px; background: #f3f7ff; font-size: 14px; line-height: 1.7; }
.orbit-action p.is-danger { border-color: #f2d2d5; background: #fff7f7; color: #dc3b48; }
.orbit-action footer { display: flex; gap: 10px; margin-top: 24px; }
.orbit-action footer button { flex: 1; height: 44px; border: 1px solid #dcdfe8; border-radius: 8px; background: #fff; color: #3d465b; font: inherit; font-size: 14px; cursor: pointer; }
.orbit-action footer button:last-child { border-color: #1f6bff; background: #1f6bff; color: #fff; font-weight: 600; }
.orbit-action footer button.is-danger { border-color: #e5484d; background: #e5484d; }
.orbit-action button:disabled { cursor: wait; opacity: .6; }
.orbit-action-enter-active, .orbit-action-leave-active { transition: opacity .24s ease; }
.orbit-action-enter, .orbit-action-leave-to { opacity: 0; }
@media (max-width: 760px) {
  .orbit-action { align-items: flex-end; padding: 0; }
  .orbit-action__panel { width: 100%; max-height: calc(100vh - 20px); max-height: calc(100dvh - 20px); overflow-y: auto; padding: 30px 18px calc(50px + env(safe-area-inset-bottom)); border-radius: 20px 20px 0 0; position: relative; }
  .orbit-action__panel::before { content: ''; position: absolute; top: 9px; left: 50%; width: 38px; height: 4px; border-radius: 4px; background: #dfe3ec; transform: translateX(-50%); }
  .orbit-action-enter-active .orbit-action__panel, .orbit-action-leave-active .orbit-action__panel { transition: transform .28s cubic-bezier(.22, .61, .36, 1); }
  .orbit-action-enter .orbit-action__panel, .orbit-action-leave-to .orbit-action__panel { transform: translateY(100%); }
}
</style>
